import type { AnalyticsActivityResponse } from '@carboncopyco/data';
import type { TimePeriod } from '@carboncopyco/types';
import { ColorHex } from '@carboncopyco/ui';
import { useEffect, useState } from 'react';
import type { ColumnChartConfigType } from '../types';
import { mapChartData } from '../utils';

const seriesNamesByTypes = {
  presented: 'Demos given',
  visited: 'Sandbox visits',
  tour: 'Tour visits',
};

export const useGetActivityChartConfig = (
  data: AnalyticsActivityResponse | undefined,
  type: 'presented' | 'visited' | 'tour',
  timePeriod: TimePeriod
) => {
  const [chartData, setChartData] = useState<ColumnChartConfigType | []>([]);

  const getConfigData = (data: AnalyticsActivityResponse) => {
    const columnStackChartDataCopy: ColumnChartConfigType = {};
    const xCategories: string[] = [];
    const resolution = data?.metadata?.resolution;

    const presentedOccurrences = mapChartData(data.results, 'occurrences');

    if (resolution === 'day') {
      columnStackChartDataCopy.step =
        timePeriod === '90' ? 7 : timePeriod === '60' ? 2 : 1;
    }

    const barRadius = resolution === 'day' ? '12%' : '5%';

    columnStackChartDataCopy.series = [
      {
        data: presentedOccurrences,
        color: type === 'presented' ? ColorHex.primary200 : ColorHex.accent1200,
        name: seriesNamesByTypes[type],
        type: 'column',
        borderRadiusTopLeft: barRadius,
        borderRadiusTopRight: barRadius,
      },
    ];

    if (presentedOccurrences.length <= 30) {
      columnStackChartDataCopy.tickAmount = 3;
    } else {
      columnStackChartDataCopy.tickAmount = 5;
    }

    data.results?.forEach((item) => {
      xCategories.push(item?.timestamp);
    });

    columnStackChartDataCopy.xCategories = xCategories;
    columnStackChartDataCopy.chartHeight = 210;
    columnStackChartDataCopy.resolution = resolution;

    setChartData(columnStackChartDataCopy);
  };

  useEffect(() => {
    if (data) {
      getConfigData(data);
    }
  }, [data]);

  return chartData;
};
